/**
 * @package buyers-experience
 */
import template from './sw-promotion-v2-wizard-description.html.twig';
import './sw-promotion-v2-wizard-description.scss';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    template,
};
